// Because performance issues, temporily
// Layout: WarningForced reflow is a likely performance bottleneck.

export default function (to, from, savedPosition) {
  if (savedPosition) {
    // This is Back History
    return savedPosition;
  } else {
    // This is Navigating Next Page
    // return { x: 0, y: 0 }
    return { left: 0, top: 0 };
  }
}
// https://nuxtjs.org/docs/features/file-system-routing/#unknown-dynamic-nested-routes
